import {business} from '@sail/icons/react/Icon';
import {Icon, view} from '@sail/ui';

export const MerchantLogo = ({
  logoUrl,
  businessName,
  style,
}: {
  logoUrl: string | null;
  businessName: string | null;
  style?: React.CSSProperties;
}) => {
  if (logoUrl) {
    return (
      <view.img
        src={logoUrl}
        alt={businessName ?? undefined}
        data-test="logo-img"
        css={{
          objectFit: 'contain',
          borderRadius: '50%',
        }}
        style={style}
      />
    );
  } else {
    return (
      <view.div
        css={{
          borderRadius: 'large',
          backgroundColor: 'offset',
          stack: 'x',
          alignX: 'center',
          alignY: 'center',
          flex: 'none',
        }}
        style={style}
      >
        <Icon icon={business} />
      </view.div>
    );
  }
};
